import { isNil } from 'lodash';
import { ImageStyle, StyleProp } from 'react-native';
import { MBView } from '@shared/components/MBView';
import { Colors, LightColorTheme, SharedStyles } from '@shared/styles';
import { User } from '@shared/types/user';
import { InitialsAvatar } from '../InitialsAvatar';
import { MBImage } from '../MBImage';

export interface MBUserImageProps {
  user?: User;
  size?: 'large' | 'normal' | 'small' | 'tiny';
  style?: StyleProp<ImageStyle>;
}

export function MBUserImage({ user, style, size = 'normal' }: MBUserImageProps) {
  if (!user) {
    return (
      <MBView center style={[style || SharedStyles.fill, { backgroundColor: Colors.v2.gray10 }]} />
    );
  }

  if (!user.imageUrl || user.imageUrl.includes('imgur.com')) {
    return (
      <LightColorTheme>
        <InitialsAvatar name={user.fullName} id={user.id} size={size} style={style} />
      </LightColorTheme>
    );
  }
  if (!isNil(user.imageUrl)) {
    return <MBImage style={style || SharedStyles.fill} source={{ uri: user.imageUrl }} />;
  }
  return null;
}
